// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"453f2ef2","455":"582c5739","977":"b6c2e695"}[chunkId] + ".chunk.js";
};